import { getToken } from "../authorization/auth";
import { API_ENDPOINT } from "../authorization/const";

export async function getAllOrgCn(data) {
    const res = await fetch(API_ENDPOINT + "booking/get-all/" + getToken() + "?interval=" + data.interval + "&start=" + data.start + "&end=" + data.end);
    if (res.status === 200) {
        return await res.json();
    }
    throw await res.json();
}

export async function deskCnPayment(data) {
    data["auth"] = getToken();
    const res = await fetch(API_ENDPOINT + "transaction/day-booking-payment", {
        method: "POST",
        body: JSON.stringify(data)
    });
    if (res.status === 200)
        return await res.json();
    throw await res.json();
}

export async function deskCnDelete(cn) {
    const data = { "auth": getToken(), "cn": cn };
    const res = await fetch(API_ENDPOINT + "booking/day-cn/delete", {
        method: "DELETE",
        body: JSON.stringify(data)
    });
    if (res.status === 200)
        return await res.json();
    throw await res.json();
}

export async function deskDataUpdate(data) {
    data["auth"] = getToken();
    const res = await fetch(API_ENDPOINT + "booking/day-cn/update", {
        method: "POST",
        body: JSON.stringify(data)
    });
    if (res.status === 200)
        return await res.json();
    throw await res.json();
}

export async function orgCnDelete(cn) {
    const data = { "auth": getToken(), "cn": cn };
    const res = await fetch(API_ENDPOINT + "booking/org-cn/delete", {
        method: "DELETE",
        body: JSON.stringify(data)
    });
    if (res.status === 200)
        return await res.json();
    throw await res.json();
}

export async function orgPriceUpdate(data) {
    data["auth"] = getToken();
    const res = await fetch(API_ENDPOINT + "booking/org-cn/update/price", {
        method: "POST",
        body: JSON.stringify(data)
    });
    if (res.status === 200)
        return await res.json();
    throw await res.json();
}

export async function orgWeightUpdate(data) {
    data["auth"] = getToken();
    const res = await fetch(API_ENDPOINT + "booking/org-cn/update/weight", {
        method: "POST",
        body: JSON.stringify(data)
    });
    if (res.status === 200)
        return await res.json();
    throw await res.json();
}

export async function orgDateUpdate(data) {
    data["auth"] = getToken();
    const res = await fetch(API_ENDPOINT + "booking/org-cn/update/date", {
        method: "POST",
        body: JSON.stringify(data)
    });
    if (res.status === 200)
        return await res.json();
    throw await res.json();
}

export async function orgLocationUpdate(data) {
    data["auth"] = getToken();
    const res = await fetch(API_ENDPOINT + "booking/org-cn/update/location", {
        method: "POST",
        body: JSON.stringify(data)
    });
    if (res.status === 200)
        return await res.json();
    throw await res.json();
}

export async function getDayBookingEdit({ interval, start, end }) {
    const add = Boolean(interval) ? "interval=" + interval : "start=" + start + "&end=" + end;
    const res = await fetch(API_ENDPOINT + "booking/day/get-all/" + getToken() + "?payment=0&" + add);
    if (res.status === 200)
        return await res.json();
    throw await res.json();
}

export async function getDayBooking({ interval, start, end }) {
    const add = Boolean(interval) ? "interval=" + interval : "start=" + start + "&end=" + end;
    const res = await fetch(API_ENDPOINT + "booking/day/get-all/" + getToken() + "?" + add);
    if (res.status === 200)
        return await res.json();
    throw await res.json();
}

export async function getDayZeroBooking() {
    const res = await fetch(API_ENDPOINT + "booking/day/get-edit/" + getToken());
    if (res.status === 200)
        return await res.json();
    throw await res.json();
}

export function getTotalAmountDayBooking(data) {
    if (data === null) return 0;
    let total = 0;
    data.forEach(item => {
        total += item.amount + item.other + item.packaging + item.pickup + item.fuel + item.gst + item.insurance
    });
    return total.toFixed(2);
}

export async function resolveQuotationPrice(data) {
    data["auth"] = getToken();
    const res = await fetch(API_ENDPOINT + "quotation/price-calculate", {
        method: "POST",
        body: JSON.stringify(data)
    });
    if (res.status === 200)
        return await res.json();
    throw await res.json();
}